import { render, staticRenderFns } from "./publcArtclDetail.vue?vue&type=template&id=a8170754&"
import script from "./publcArtclDetail.vue?vue&type=script&lang=js&"
export * from "./publcArtclDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports